import Vue from 'vue'
import { USER_INFO, ACCESS_TOKEN, REFERRER, LANGUAGE } from '../mutation-types'
import { getUserInfoByHideCode, logout, transformLoginByOther, selMuchTransformLogin } from '@/api/sso/user'
import { getUserOnlineSubCodeEncry } from '@/api/sso/subject'
import { queryMsgNoticePage } from '@/api/index'

const user = {
  state: {
    token: '',
    referrer: '',
    notification: {}, // 未读消息提醒
    info: {}, // 用户信息
    needBack: false // 退出时 是否返回 原来跳转我们的网站时的登录地址，如果false,就返回我们自己的登录页，true，就返回他们的登录页
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      Vue.ls.set(ACCESS_TOKEN, token)
    },
    SET_REFERRER: (state, referrer) => {
      state.referrer = referrer
      Vue.ls.set(REFERRER, referrer)
    },
    SET_NOTIFICATION: (state, notification) => {
      state.notification = notification
    }
  },
  actions: {
    // 根据token自动登录
    AutoLogin ({ commit, dispatch }, query) {
      const { token, needBack, systemCode, resource } = query
      const referrer = window.document.referrer
      if (resource === 'SELMUCH_ADS') {
        return new Promise((resolve) => {
          selMuchTransformLogin({ token }).then(({ data }) => {
            if (data?.token) {
              commit('SET_TOKEN', data.token)
              resolve()
            }
          })
        })
      }
      switch (systemCode) {
        case 'KJY':
          return dispatch('TransformLoginByOther', query)
        default: {
          commit('SET_TOKEN', token)
          needBack && commit('SET_REFERRER', referrer)
          return new Promise((resolve, reject) => {
            dispatch('GetUserInfo')
              .then(resolve)
              .catch(() => {
                Vue.ls.clear()
                if (needBack) {
                  setTimeout(() => {
                    window.location.href = referrer
                  }, 3000)
                }
                reject(needBack)
              })
          })
        }
      }
    },
    // 根据第三方token自动登录
    TransformLoginByOther ({ commit }, query) {
      const params = {
        systemCode: query.systemCode,
        token: query.token
      }
      return transformLoginByOther(params).then(({ data }) => {
        commit('SET_TOKEN', data)
      })
    },
    GetUserInfo () {
      return new Promise((resolve, reject) => {
        getUserInfoByHideCode()
          .then(res => {
            Vue.ls.set(USER_INFO, res.data)
            resolve(res)
          })
          .catch(reject)
      })
    },
    Logout () {
      const referrer = Vue.ls.get(REFERRER)
      return new Promise((resolve) => {
        if (window.location.pathname.startsWith('/login')) return resolve()

        logout()
          .finally(() => {
            console.log('进来了')
            Vue.ls.clear()
            localStorage.removeItem('X-Auth-Token') // 清空amazon运营登陆状态
             window.location.href = referrer || '/login'
            resolve()
          })
      })
    },
    ClearDateAfterLogout ({ commit, dispatch }) {
      let lang = Vue.ls.get(LANGUAGE)
      window.localStorage.clear()
      window.sessionStorage.removeItem('firstCreateTipsFlag')
      Vue.ls.set(LANGUAGE, lang)
      document.title = '易仓用户中心' // 浏览器标题恢复：易仓用户中心
    },
    OpenSaleConsult ({ commit }, systemCode = 'ERP') {
      getUserOnlineSubCodeEncry({ systemCode: 'SSO_SYS_USER' }).then(res => {
        const { subjectCodeEncrypt, companyName, packageInfoOnlineDTOS } = res.data
        const { phone, nickName, userId } = Vue.ls.get(USER_INFO)
        const origin = 'https://im.7x24cc.com/phone_webChat.html'
        const chatIdMap = {
          ERP: '1bb826d2-26de-4628-a252-38cd41176060',
          SYS_LISTING: '3dbf76e2-7f7c-42a5-be55-e8942d1588a3',
          AMAZON_OPERATE: 'bbe43831-c731-4ad3-9163-4e584ba321dc',
          M2B: 'ba09a5df-d7d9-4f9a-8918-516ae619ae29',
          WMS: 'c784a961-c3d9-411b-abac-f73d8456c7f4',
          TMS: '809a62a8-7c65-4686-99ee-fe7f73d5bee8'
        }
        const defaultChatID = chatIdMap['ERP']
        const packageNames = packageInfoOnlineDTOS instanceof Array ? '-套餐: ' + packageInfoOnlineDTOS.map(item => item.packageName).join('、') : ''
        const packageIds = packageInfoOnlineDTOS instanceof Array ? packageInfoOnlineDTOS.map(item => item.packageId).join('z') : ''
        const data = {
          accountId: 'N000000020843',
          AgentId: '7c4f05b0-e1e7-11ea-b302-9578a53c6dc9',
          nickName: (companyName || phone || nickName) + packageNames,
          chatId: chatIdMap[systemCode] || defaultChatID,
          visitorId: subjectCodeEncrypt + userId + packageIds
        }
        const URL = `${origin}?${Object.keys(data).map(key => `${key}=${data[key]}`).join('&')}`

        window.open(URL, '_blank')
      })
    },
    queryMsgNoticePage ({ commit }) {
      queryMsgNoticePage({
        hasRead: 2,
        pageSize: 4
      }).then(({ dataList, noReadCount }) => {
        commit('SET_NOTIFICATION', { dataList, noReadCount })
      })
    }
  }
}

export default user
